/*
 * @description:
 * @author: Jason Wong
 * @since: 2022-04-21 13:28:50
 */
export default {
  install(vue, options) {
    vue.prototype.$$try = async function (closable, act, catchHandler) {
      if (!closable || !act) return;

      let innerError = null;
      try {
        await act();
      } catch (err) {
        innerError = err;
      }
      !!closable.close && closable.close();
      console.log('#-# $$try',innerError,catchHandler);
      if (!!innerError && !!catchHandler) {
        catchHandler(innerError);
      }
    };
  },
};
